import { render, staticRenderFns } from "./AuthChooseItem.vue?vue&type=template&id=61b515c8&scoped=true"
import script from "./AuthChooseItem.vue?vue&type=script&lang=js"
export * from "./AuthChooseItem.vue?vue&type=script&lang=js"
import style0 from "./AuthChooseItem.vue?vue&type=style&index=0&id=61b515c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b515c8",
  null
  
)

export default component.exports